var path = 'src/app/patients/pkd/liver-imaging.html';
var html = "<h1 class=page-header>Liver Imaging</h1> <div liver-imaging-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/pkd/liver-imaging.html
 ** module id = 510
 ** module chunks = 0
 **/